import { uniqueExcelSheetNames } from '@/utils/excelSheetName';
import { xlsxBlob } from '@/utils/xlsxWorkbook';

import type { ExportColumnDefinition } from '../types';

function cellValue<T>(row: T, column: ExportColumnDefinition<T>): string | number {
    const value = row[column.key];
    if (value === null || value === undefined) {
        return '';
    }
    if (column.formatter) {
        return column.formatter(value);
    }
    if (typeof value === 'string' || typeof value === 'number') {
        return value;
    }
    return '';
}

export function tableFromRows<T>(
    columns: ExportColumnDefinition<T>[],
    rows: T[],
    translate: (key: string) => string
): { header: string[]; rows: (string | number)[][] } {
    return {
        header: columns.map((col) => translate(col.labelKey)),
        rows: rows.map((row) => columns.map((col) => cellValue(row, col))),
    };
}

export function generateCSV(
    dailyTitle: string,
    dailyHeader: string[],
    dailyRows: (string | number)[][],
    environmentalTitle: string,
    environmentalHeader: string[],
    environmentalRow: (string | number)[]
): Blob {
    const csvContent = [
        dailyTitle,
        `#${dailyHeader.join(',')}`,
        ...dailyRows.map((row) => row.join(',')),
        '',
        environmentalTitle,
        environmentalHeader.join(','),
        environmentalRow.join(','),
    ].join('\n');

    return new Blob([csvContent], {
        type: 'data:text/csv;charset=utf-8',
    });
}

export async function generateXLSX(
    dailySheetName: string,
    dailyHeader: string[],
    dailyRows: (string | number)[][],
    environmentalSheetName: string,
    environmentalHeader: string[],
    environmentalRow: (string | number)[]
): Promise<Blob> {
    const [behaviorName, envName] = uniqueExcelSheetNames([dailySheetName, environmentalSheetName]);
    return xlsxBlob([
        { name: behaviorName, rows: [dailyHeader, ...dailyRows] },
        { name: envName, rows: [environmentalHeader, environmentalRow] },
    ]);
}
